var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMagnifier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4607_91488)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 0.5)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7429 10.8461C12.7112 9.52474 13.1449 7.88654 12.9572 6.2592C12.7695 4.63186 11.9743 3.13539 10.7307 2.06918C9.48701 1.00297 7.88665 0.445657 6.24973 0.50873C4.61282 0.571803 3.06008 1.25062 1.90217 2.40936C0.744249 3.56811 0.0665484 5.12133 0.00464653 6.75829C-0.0572553 8.39524 0.501207 9.99521 1.56831 11.2381C2.6354 12.481 4.13244 13.2751 5.75992 13.4616C7.38739 13.6482 9.02528 13.2133 10.3459 12.2441H10.3449C10.3749 12.2841 10.4069 12.3221 10.4429 12.3591L14.2929 16.2091C14.4804 16.3967 14.7348 16.5022 15 16.5023C15.2653 16.5023 15.5198 16.3971 15.7074 16.2096C15.895 16.022 16.0005 15.7677 16.0006 15.5024C16.0007 15.2371 15.8954 14.9827 15.7079 14.7951L11.8579 10.9451C11.8221 10.9089 11.7837 10.8754 11.7429 10.8451V10.8461ZM12.0009 7.00205C12.0009 7.72432 11.8586 8.43952 11.5822 9.10681C11.3058 9.7741 10.9007 10.3804 10.39 10.8911C9.87926 11.4019 9.27295 11.807 8.60566 12.0834C7.93837 12.3598 7.22317 12.5021 6.5009 12.5021C5.77863 12.5021 5.06343 12.3598 4.39614 12.0834C3.72885 11.807 3.12253 11.4019 2.61181 10.8911C2.10109 10.3804 1.69596 9.7741 1.41956 9.10681C1.14316 8.43952 1.0009 7.72432 1.0009 7.00205C1.0009 5.54336 1.58036 4.14442 2.61181 3.11297C3.64326 2.08152 5.04221 1.50205 6.5009 1.50205C7.95959 1.50205 9.35853 2.08152 10.39 3.11297C11.4214 4.14442 12.0009 5.54336 12.0009 7.00205Z",
    fill: "#76B72A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4607_91488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMagnifier);
export default __webpack_public_path__ + "static/media/ic-magnifier.0f5b5c0895b6cbf9f671c0ba34c362a0.svg";
export { ForwardRef as ReactComponent };